export const commonTheme = {
  fonts: {
    Inter: "Inter"
  },
  fontSizes: {
    r: "15px",
    s: "14px"
  },
  colors: {
    pink: "#ffb8aa",
    green: "#1bbc9b",
    darkBlue: "#14132d",
  },
  media: {
    desktop: "1920px",
    desktopMd: "1600px",
    desktopSm: "1336px",
    tab: "1240px",
    tabMd: "1024px",
    tabSm: "767px",
    mob: "500px",
    mobSm: "350px",
  },
}

export const darkTheme = {
  name: 'dark',
  PRIMARY_BACKGROUND_COLOR: "#222c41",
  SECONDARY_BACKGROUND_COLOR: "#333e53",
  TERTIARY_BACKGROUND_COLOR: "#37445a",
  QUATERNARY_BACKGROUND_COLOR: "#5d6578",
  QUINARY_BACKGROUND_COLOR: "#939bb1",
  SENARY_BACKGROUND_COLOR: "#acb6cf",
  BACKGROUND_COLOR: "#3c4a61",
  PRIMARY_TEXT_COLOR: "#000000",
  PRIMARY: "#ffc048",
  THEME_SWITCHER_BACKGROUND: "#ffc048",
  THEME_SWITCHER_COLOR: "#b17637",
  THEME_BUTTON_BACKGROUND_A: "#20c6b2",
  THEME_BUTTON_COLOR_A: "#222c41",
  LINK_COLOR_A: "#ffc048",
  SUCCESS_TODO_COLOR: "#20c6b2",
  SUCCESS_TODO_COLOR2: "#1a9685",
  PROGRESS_TODO_COLOR: "#9ba5e5",
  PROGRESS_TODO_COLOR2: "#727aa8",
  WAITING_TODO_COLOR: "#ee9f4b",
  WAITING_TODO_COLOR2: "#B17637",
  CORRECT_SYMBOLS: "#20c6b2",
  WRONG_SYMBOLS: "red",
  SYMBOLS: "rgba(255, 255, 255, .2)",
  SYMBOLS_NOT_EDIT: "#CCC",
}

export const lightTheme = {
  name: 'light',
  PRIMARY_BACKGROUND_COLOR: "#aaa",
  SECONDARY_BACKGROUND_COLOR: "#bbb",
  TERTIARY_BACKGROUND_COLOR: "#cacaca",
  QUATERNARY_BACKGROUND_COLOR: "#e3e3e3",
  QUINARY_BACKGROUND_COLOR: "#ffffff",
  SENARY_BACKGROUND_COLOR: "#FFFFFF",
  BACKGROUND_COLOR: "#e3e3e3",
  PRIMARY_TEXT_COLOR: "#ffffff",
  PRIMARY: "#55aacc",
  THEME_SWITCHER_BACKGROUND: "#ffffff",
  THEME_SWITCHER_COLOR: "#5bbae3",
  THEME_BUTTON_BACKGROUND_A: "#4890ae",
  THEME_BUTTON_COLOR_A: "#eeeeee",
  LINK_COLOR_A: "#55aacc",
  SUCCESS_TODO_COLOR: "#55aacc",
  SUCCESS_TODO_COLOR2: "#4285a0",
  PROGRESS_TODO_COLOR: "#9ba5e5",
  PROGRESS_TODO_COLOR2: "#727aa8",
  WAITING_TODO_COLOR: "#ee9f4b",
  WAITING_TODO_COLOR2: "#B17637",
  CORRECT_SYMBOLS: "#55aacc",
  WRONG_SYMBOLS: "red",
  SYMBOLS: "rgba(255, 255, 255, .5)",
  SYMBOLS_NOT_EDIT: "#FFFFFF",
}